import { Skeleton } from '@gitbook/spine-react';

/**
 * Skeleton for the document of the page.
 */
export function PageDocumentSkeleton() {
    return (
        <div className="flex flex-col gap-6">
            <ParagraphSkeleton lines={3} />
            <ParagraphSkeleton lines={2} />
        </div>
    );
}

function ParagraphSkeleton(props: { lines: number }) {
    return (
        <div className="flex flex-col gap-2">
            {Array.from({ length: props.lines }).map((_, index) => (
                <Skeleton key={index} shape="rect" className="h-4 w-full" />
            ))}
            <Skeleton shape="rect" className="h-4 w-1/2" />
        </div>
    );
}
